import _get from 'lodash/get';

export const hasEmbeddedControls = () => _get(window, 'xprops.controls', false);

export const isEmbedded = () => _get(window, 'xprops.embed', false);

export const isBareEmbedded = () =>
  isEmbedded() && _get(window, 'xprops.type') === 'bare';

export const hidePageHeader = () =>
  isEmbedded() &&
  hasEmbeddedControls() &&
  _get(window, 'xprops.controls.hideHeader', false);

export const hidePageSidebar = () =>
  isEmbedded() &&
  hasEmbeddedControls() &&
  _get(window, 'xprops.controls.hideSidebar', false);

export const embeddedStyles = () => _get(window, 'xprops.styles', {});

export const isValidPadding = paddingString => {
  // This regex checks for patterns like "10px", "10%", "10em", "10rem", "10vw", "10vh", "auto", etc.
  const unitPattern =
    '(\\d*\\.?\\d+(px|em|rem|%|vh|vw|ch|ex|cm|mm|in|pt|pc|vmin|vmax)|auto)';

  // Build the full pattern.
  const pattern = new RegExp(`^${unitPattern}(\\s+${unitPattern}){0,3}$`);

  return pattern.test(paddingString);
};

export const hasDynamicIframeHeight = () =>
  isEmbedded() &&
  typeof _get(window, 'xprops.setIframeHeight', '') === 'function';

export const getEmbeddedContainerUrl = () => {
  if (!isEmbedded()) return null;
  return _get(window, 'xprops.parentUrl', null);
};

export const getSubBrand = () => {
  if (!isEmbedded()) return null;
  const subBrand = _get(
    window,
    'xprops.subBrand',
    _get(window, 'xprops.subbrand', null),
  );
  return subBrand;
};

export const getParentPosition = async () => {
  if (!isEmbedded()) return null;
  const hasOnModalOpenProps =
    typeof _get(window, 'xprops.onModalOpen', '') === 'function';
  const parentPosition = hasOnModalOpenProps
    ? await _get(window, 'xprops.onModalOpen', '')()
    : null;
  return parentPosition;
};
